// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emailGame_loader__1tNjk {\n  height: 2rem;\n  width: 100%;\n  position: relative;\n}", ""]);
// Exports
exports.locals = {
	"loader": "emailGame_loader__1tNjk"
};
module.exports = exports;
